import {
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Container, Spinner } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer } from "react-toastify";
import { createApplicationAction } from "../../../../redux/actions/ApplicationAction";
import notify from "../../../../Notifcation";
import { useNavigate } from "react-router-dom";

const FaqedLec = () => {
  const [NATIONID, setNATIONID] = useState("");
  const [namee, setnamee] = useState("");
  const [datelec, setdatelec] = useState("");
  const [desc, setdesc] = useState("");
  const [mahder, setmahder] = useState("");

  const [Nationalid, setNationalid] = useState("");
  const [Others, setOthers] = useState([]);

  const navegate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [isPress, setisPress] = useState(false);
  const handleFileChangeNational = (e) => {
    // Convert FileList to Array
    const files = Array.from(e.target.files);
    setNationalid(files);
  };
  const handleFileChangeOther = (e) => {
    // Convert FileList to Array
    const files = Array.from(e.target.files);
    setOthers(files);
  };
  const handlesubmit = async (e) => {
    e.preventDefault();
    if (
      namee === "" ||
      Nationalid === "" ||
      NATIONID === "" ||
      datelec === ""||mahder === "" 
    ) {
      notify("من فضلك اكمل البيانات المطلوبة", "error");
      return;
    }
    setisPress(true);
    const formData = new FormData();
    formData.append("application_type", 5);
    formData.append("traffic_category", 1);
    formData.append("traffic_type", "instead");
    formData.append("recored", mahder);

    formData.append(
      "client_data",
      JSON.stringify({
        name: namee,
        national_id: NATIONID,
        details: desc,
        licence_du_date: datelec,
      })
    );
    Nationalid.map((item) => {
      return formData.append("client_national_ids", item);
    });
    Others.map((item) => {
      return formData.append("others", item);
    });
    await dispatch(createApplicationAction(formData));
    setLoading(false);
    setisPress(false);
    setnamee("");
    setmahder("")
    setdatelec("");
    setNATIONID("");
    setdesc("");
    setNationalid("");
  };
  const res = useSelector((state) => state.ApplicationReduser.createApp);

  useEffect(() => {
    if (loading === false) {
      setTimeout(() => setLoading(true), 1500);
      if (res) {
        if (res.status === 201 || res.status === 200) {
          if (res.data) {
            notify(res.data.message, "success");
            setTimeout(() => {
              navegate("/user/requestsuser");
            }, 3000);
          }
        } else if (res.status !== 201 || res.status !== 200) {
          if (res.data) {
            notify(res.data.message, "error");
          } else {
            notify("حدثة مشكلة حاول مرة اخرى", "error");
          }
        }
      }
    }
  }, [loading]);
  return (
    <Container>
      {" "}
      <h3 className="text-center mb-3 mt-3">استخراج بدل فاقد</h3>
      <div className="inputs-container">
        <div className="inp-container ">
          <TextField
            label={
              <Typography>
                الأسم
                <span style={{ color: "red", fontSize: "21px" }}>*</span>
              </Typography>
            }
            type="text"
            value={namee}
            onChange={(e) => {
              setnamee(e.target.value);
            }}
            variant="outlined"
          />
        </div>
        <div className="inp-container ">
          <TextField
            label={
              <Typography>
                الرقم القومي
                <span style={{ color: "red", fontSize: "21px" }}>*</span>
              </Typography>
            }
            type="number"
            value={NATIONID}
            onChange={(e) => {
              setNATIONID(e.target.value);
            }}
            variant="outlined"
          />
        </div>
        <div className="inp-container ">
          <TextField
            focused
            label={
              <Typography>
                تاريخ انتهاء الرخصة
                <span style={{ color: "red", fontSize: "21px" }}>*</span>
              </Typography>
            }
            type="date"
            value={datelec}

            onChange={(e) => {
              setdatelec(e.target.value);
            }}
            variant="outlined"
          />
        </div>
        <div className="inp-container ">
          <TextField
            label={"تفاصيل"}
            multiline
            type="text"
            value={desc}
            onChange={(e) => {
              setdesc(e.target.value);
            }}
            variant="outlined"
          />
        </div>
        <div className="inp-container ">
          <TextField
            label={
              <Typography>
                 المحضر
                <span style={{ color: "red", fontSize: "21px" }}>*</span>
              </Typography>
            }
            focused
            type="file"
            onChange={(e)=>setmahder(e.target.files[0])}
            variant="outlined"
          />
        </div>
        <div className="inp-container ">
          <TextField
            label={
              <Typography>
                البطاقة الشخصية
                <span style={{ color: "red", fontSize: "21px" }}>*</span>
              </Typography>
            }
            focused
            inputProps={{
              multiple: true,
            }}
            type="file"
            onChange={handleFileChangeNational}
            variant="outlined"
          />
        </div>
        <div className="inp-container ">
          <TextField
            label={"اخرى"}
            focused
            inputProps={{
              multiple: true,
            }}
            type="file"
            onChange={handleFileChangeOther}
            variant="outlined"
          />
        </div>
        <div className="inp-container "></div>
        <div className="inp-container "></div>
      </div>
      {isPress && loading ? (
        <button className="buttonadd">
          <Spinner />
        </button>
      ) : (
        <button className="buttonadd" onClick={handlesubmit}>
          {" "}
          استكمال الطلب
        </button>
      )}
      <ToastContainer />
    </Container>
  );
};

export default FaqedLec;
